import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

// Redux
import {
  getSurveyAnswer,
  postSurveyAnswer,
} from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'


class QuizSurvey extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      answer: 0,
      loading: false,
    }

    this.handleAnswerChange = this.handleAnswerChange.bind(this)
    this.handleClickSubmit = this.handleClickSubmit.bind(this)
  }

  componentDidMount() {
    analytics.page('quiz-survey')
    this.props.getSurveyAnswer(this.props.match.params.id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.surveyAnswered) {
      this.props.history.push(`/quiz/${this.props.match.params.id}/results`)
    }
  }

  handleAnswerChange(e) {
    this.setState({
      answer: parseInt(e.target.value, 10),
    })
  }

  handleClickSubmit() {
    this.setState({
      loading: true,
    })
    this.props.postSurveyAnswer(this.props.match.params.id, this.state.answer)
  }

  render() {
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove">
            <div className="uk-text-center">
              <h2>What is your role?</h2>
              <h4 className="uk-margin-remove-top">&nbsp;</h4>
            </div>
          </div>
        </div>

        <div className="uk-cover-container">
          <div className="uk-container">
            <div className="uk-section uk-margin-medium-bottom uk-padding-large uk-text-center">
              <div className="uk-flex uk-flex-center">
                <form>
                  <fieldset className="uk-fieldset">
                    <table className="uk-text-left">
                      <tbody>
                        <tr>
                          <td>
                            <input
                              className="uk-radio"
                              type="radio"
                              name="answer"
                              checked={(this.state.answer === 0)}
                              value={0}
                              onChange={this.handleAnswerChange}
                              style={{ paddingRight: 10 }}
                            />
                            Software Engineering/Development
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              className="uk-radio"
                              type="radio"
                              name="answer"
                              checked={(this.state.answer === 1)}
                              value={1}
                              onChange={this.handleAnswerChange}
                              style={{ paddingRight: 10 }}
                            />
                            Security
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              className="uk-radio"
                              type="radio"
                              name="answer"
                              checked={(this.state.answer === 2)}
                              value={2}
                              onChange={this.handleAnswerChange}
                              style={{ paddingRight: 10 }}
                            />
                              Non Software/Security role
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                  {(this.state.loading) ? (
                    <span data-uk-spinner="" />
                  ) : (
                    <Link to="#" className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large" onClick={this.handleClickSubmit}>
                      Submit Answer
                    </Link>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  surveyAnswered: state.quiz.surveyAnswered,
})

const mapDispatchToProps = dispatch => ({
  getSurveyAnswer: (quizId) => { dispatch(getSurveyAnswer(quizId)) },
  postSurveyAnswer: (quizId, answer) => { dispatch(postSurveyAnswer(quizId, answer)) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizSurvey))
